import * as Action from '../action';
import { CART_TAB_CIP } from '../../constant';

const initialState = {
  selectedTab: 2,
  cancellingOutstandingOrderStatus: false,
  selectedInnerTab: CART_TAB_CIP,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Action.SET_CANCELLING_OUTSTANDING_ORDER_STATUS:
      return { ...state, cancellingOutstandingOrderStatus: action.status };
    case Action.SET_MY_PAYMENT_SELECTED_TAB:
      return { ...state, selectedTab: action.value };
    case Action.SET_MY_PAYMENT_SELECTED_INNER_TAB:
      return { ...state, selectedInnerTab: action.value };
    default:
      return state;
  }
};
